export default __webpack_public_path__ + "static/media/resume.bf993a68.svg";